import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p>© 2021 Samsung. All Rights Reserved.</p>
    </div>
  );
};

export default Footer;
